import { useParams } from 'react-router-dom'

import { DataBenchHubPage } from '@/components/platform/platform-data-bench-hub'
import { DataBenchRunPage } from '@/components/platform/platform-data-bench-run'
import { DataBenchWorldPage } from '@/components/platform/platform-data-bench-world'
import { useSimulationScenario } from '@/hooks/use-platform-simulation'
import { isProductWorldScenario } from '@/lib/platform-data-bench-copy'
import { PageContainer } from '@/components/ui/page-container'

export function PlatformSimulationPage() {
  const { scenarioId } = useParams<{ scenarioId?: string }>()
  if (!scenarioId) {
    return <DataBenchHubPage />
  }
  return <DataBenchScenarioGate scenarioId={scenarioId} />
}

function DataBenchScenarioGate({ scenarioId }: { scenarioId: string }) {
  const { data: scenario, isLoading, error } = useSimulationScenario(scenarioId)
  if (isLoading) {
    return (
      <PageContainer>
        <p className="text-sm text-muted-foreground">Loading run…</p>
      </PageContainer>
    )
  }
  if (error || !scenario) {
    return <DataBenchRunPage scenarioId={scenarioId} />
  }
  if (isProductWorldScenario(scenario)) {
    return <DataBenchWorldPage scenarioId={scenarioId} />
  }
  return <DataBenchRunPage scenarioId={scenarioId} />
}
